import React, { createContext, useReducer, useEffect, ReactChild, ReactChildren } from 'react';
import { SessionReducerType, sessionReducer } from '../reducers/SessionReducer';
import { LocalStorageKeys, readLocalStorage, setLocalStorage } from '../utils/localStorageHelper';
import { SessionContextDto } from './dtos/SessionContextDto';

export const SessionContext = createContext<{ state: SessionContextDto; dispatch: React.Dispatch<SessionReducerType> }>({
  state: new SessionContextDto(),
  dispatch: () => undefined,
});

const SessionContextProvider = (props: AuxProps) => {
  const [session, dispatch] = useReducer(sessionReducer, new SessionContextDto(), () => {
    if (typeof window !== 'undefined') {
      return new SessionContextDto(readLocalStorage<SessionContextDto>(LocalStorageKeys.SessionContext, new SessionContextDto()));
    }
    return new SessionContextDto();
  });

  useEffect(() => {
    setLocalStorage(LocalStorageKeys.SessionContext, session);
  }, [session]);

  return <SessionContext.Provider value={{ state: session, dispatch }}>{props.children}</SessionContext.Provider>;
};

export default SessionContextProvider;

export interface AuxProps {
  children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[];
}
